import React, { FC, useState, useEffect, CSSProperties,useMemo } from "react";
import useFetch from "hooks/useFetch"; // Asegúrate de importar tu hook useFetch correctamente
import config from "config.json";
import StayDatesRangeInputView from "containers/ListingDetailPage/listing-stay-detail/StayDatesRangeInputView";
import GuestsInputView from "containers/ListingDetailPage/listing-stay-detail/GuestsInputView";
import { useNavigate } from "react-router-dom";
import SectionHotelData from "containers/ListingDetailPage/(components)/SectionHotelData";
import SectionGuestDistribution from "containers/ListingDetailPage/(components)/SectionGuestDistribution";
import Input from "shared/Input/Input";
import Label from "components/Label/Label";

interface CheckOutPagePageMainProps {
  className?: string;
}

interface Habitacion {
  cantidad_ocupantes: number;
  codigo_habitacion: string;
  descripcion_categoria: string;
  temporada: Temporada[];
  subtotal_habitacion: number;
  ocupantes: Ocupante[];
}

interface Temporada {
  id_temporada: number;
  descripcion_temporada: string;
  dias_temporada: number;
  condiciones: Condicion[];
  subtotal_temporada: number;
  total_temporada: number;
}

interface Condicion {
  codigo_condicion: string;
  descripcion_condicion: string;
  cantidad_ocupantes: number;
  base_personas_ocupadas: BasePersona[];
  subtotal: number;
}

interface BasePersona {
  base_por_persona: number;
  cant_personas_condicion: number;
  monto: number;
  subtotal: number;
}

interface Ocupante {
  id: number;
  dni: string;
  apellidoNombre: string;
  condicion: string;
  fechaNacimiento: string;
}
interface Occupant {
  codigo_habitacion: string;
  id: number;
  dni: string;
  apellido_nombre: string;
  condicion: string;
  fecha_nac: string;
}
interface PreferenceData {
  preference_code: string;
  monto_senia: string;
}
interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageDataResponse {
  default_image: string;
  hoteles: HotelImage[];
}

interface DataPago {
  cod_hotel: string;
  banco: string;
  nro_cuenta: string;
  cbu: string;
  alias: string;
  titular: string;
}

const TransferPayment: FC<CheckOutPagePageMainProps> = ({
  className = "",
}) => {
    
  const formatDate = (dateString?: string): string => {
    // Helper function to get the default date in YYYY-MM-DD format
    const getDefaultDate = (offsetDays: number = 0) => {
      const date = new Date();
      date.setDate(date.getDate() + offsetDays);
      return date.toISOString().split('T')[0];
    };

    // Retrieve dates from sessionStorage
    let startDisp = sessionStorage.getItem("start_disp");
    let endDisp = sessionStorage.getItem("end_disp");

    // Set default dates if they do not exist
    if (!startDisp) {
      startDisp = getDefaultDate(); // Today's date
      sessionStorage.setItem("start_disp", startDisp);
    }

    if (!endDisp) {
      endDisp = getDefaultDate(3); // Today's date plus 3 days
      sessionStorage.setItem("end_disp", endDisp);
    }

    // Use the provided dateString if available, otherwise use startDisp or endDisp
    const dateToFormat = dateString || startDisp || endDisp;

    // Function to parse date in MM/DD/YYYY format
    const parseMMDDYYYY = (date: string) => {
      const [month, day, year] = date.split('/').map(part => part.padStart(2, '0'));
      return new Date(`${year}-${month}-${day}`);
    };

    // Function to parse date in YYYY-MM-DD format
    const parseYYYYMMDD = (date: string) => {
      return new Date(date);
    };

    // Determine which format the input is in and parse accordingly
    let parsedDate: Date;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateToFormat)) {
      // YYYY-MM-DD format
      parsedDate = parseYYYYMMDD(dateToFormat);
    } else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateToFormat)) {
      // MM/DD/YYYY format with single-digit month or day
      parsedDate = parseMMDDYYYY(dateToFormat);
    } else {
      console.error('Formato de fecha no válido:', dateToFormat);
      return ''; // Return an empty string or handle as needed
    }

    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) {
      console.error('Fecha no válida:', dateToFormat);
      return ''; // Return an empty string or handle as needed
    }

    return parsedDate.toISOString().split('T')[0];
  };

  function isPagoCompleto(): boolean {
    const storedDate: string | null = sessionStorage.getItem('start_disp');

    if (!storedDate) {
      return false; // Default to false if no date is stored
    }

    const startDate = new Date(storedDate); // Convert string to Date
    const currentDate = new Date();

    if (isNaN(startDate.getTime())) {
      throw new Error("Invalid date format in sessionStorage."); // Handle invalid dates
    }

    const diffInTime = startDate.getTime() - currentDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays <= 3;
  }

  const pagoCompleto = isPagoCompleto();
  const [occupants, setOccupants] = useState<Occupant[]>([]);
  const hotel_code = sessionStorage.getItem("selected_hotel");
  const access_token = sessionStorage.getItem("user_token");
  const guest = sessionStorage.getItem("guests_checkout");
  const dateFrom = formatDate(sessionStorage.getItem("start_disp") ?? '');
  const dateTo = formatDate(sessionStorage.getItem("end_disp") ?? '');
  const [totalGuests, setTotalGuests] = useState<string>("");
  const [hotelImage, setHotelImage] = useState<string>("");
  const [confirmacion, setConfirmacion] = useState<boolean>(true);
  const additionalInfo = sessionStorage.getItem('informacion_adicional_reserva')
    ? JSON.parse(sessionStorage.getItem('informacion_adicional_reserva') || "{}").informacion_adicional_habitaciones
    : { "informacion_adicional_habitaciones": "No hay información disponible" };

  const [preReservaPayload, setPreReservaPayload] = useState<any>(
    {
      es_confirmacion: confirmacion,
      hotel: hotel_code,
      desde: dateFrom,
      hasta: dateTo,
      ocupantes: JSON.parse(guest?.toString() || "[]"),
      informacion_adicional_habitaciones: additionalInfo,
      pago_total: isPagoCompleto()

    }
  );
  const [showPaymentForm, setShowPaymentForm] = useState<boolean>(false); // Nuevo estado para mostrar el formulario
  const [errorMessage, setErrorMessage] = useState<string | null>(null); // Nuevo estado para mensajes de error
  const [hotel, setHotel] = useState<any>(null); // Estado inicial para el hotel
  // Estado para los datos mockeados
  const [datosMockeados, setDatosMockeados] = useState<any>(null);

  const [showModal, setShowModal] = useState(false)
  const [titleModal, setTitleModal] = useState("Titulo")
  const [contentModal, setContentModal] = useState("contenido")

  const { data: hotelImagesData, error: hotelImagesError, fetchData: fetchHotelImages } = useFetch<HotelImageDataResponse>(
    "GET",
    `${config.backend_url}/setia/hoteles/ver_todas_fotos`,
    { "Content-Type": "application/json" }
  );


  const { data, isLoading, error, fetchData } = useFetch(
    "GET",
    `${config.backend_url}/setia/hotel/detalle?codigo=${hotel_code}`,
    { "Content-Type": "application/json" }
  );

  const { data: dataPreReserva, isLoading: isLoadingPreReserva, error: errorPreReserva, fetchData: fetchDataPreReserva } = useFetch(
    "POST",
    `${config.backend_url}/setia/reservas/prereserva`,
    preReservaPayload,
    { "Content-Type": "application/json" }
  );

  const [datosPago, setDatosPago] = useState([])

  const { data: dataDatosPago, isLoading: isLoadingDatosPago, error: errorDatosPago, fetchData: fetchDataDatosPago } = useFetch(
    "GET",
    `${config.backend_url}/setia/hoteles/datos_pago?cod_hotel=${hotel_code}`,
    null,
    {}    
  )

  useEffect(() => {
    const initialHeight = window.innerHeight; // Guardar la altura inicial del viewport

    const handleResize = () => {
      const currentHeight = window.innerHeight;
      if (initialHeight - currentHeight > 150) {
        // El teclado probablemente está abierto, evita re-renderizaciones innecesarias
        console.log('El teclado se ha abierto.');
      } else {
        console.log('Resize real detectado.');
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchHotelImages(); // Llama para obtener las imágenes
    fetchData(); // Llama para obtener los detalles del hotel
  }, []);

  useEffect(() => {
    if (hotelImagesData) {
      const hotelData = hotelImagesData.hoteles.find(
        (hotel) => hotel.hotel_code === hotel_code
      );

      if (hotelData) {
        setHotelImage(hotelData.photos[0]);
      } else {
        setHotelImage(hotelImagesData.default_image);
      }
    }
  }, [hotelImagesData]);

  useEffect(() => {
    const reserva = dataPreReserva as any;
    if (dataPreReserva && reserva.preference_code) {
      sessionStorage.setItem("id_preferencia", reserva.preference_code);
      setbodyCrearReserva(prev => ({
        ...prev,codigo_pre_reserva: reserva.codigo_reserva
      }));
      sessionStorage.setItem("titulo_preferencia", reserva.titulo_prereserva.replace(/\//g, ' '));
      sessionStorage.setItem("preference_amount", reserva.monto_senia);
      setShowPaymentForm(true);
    } else if (errorPreReserva) {
      setErrorMessage("Error al obtener el ID de preferencia de pago.");
      pauseTimer()
    }
  }, [dataPreReserva, errorPreReserva]);

  useEffect(() => {
    const occupantsData = sessionStorage.getItem("guests_checkout");
    if (occupantsData) {
      setOccupants(JSON.parse(occupantsData));
    }

    fetchData(); // Llama a fetchData para obtener datos del backend

    fetchDataPreReserva();
    fetchDataDatosPago();
  }, []);

  useEffect(() => {
    renderTransferPaymentForm();
  }, [showPaymentForm]);

  useEffect(() => {
    if (dataPreReserva) {
      setDatosMockeados(dataPreReserva);
      setShowPaymentForm(true);
    }
  }, [dataPreReserva]);

  useEffect(() => {
    if (data) {
      setHotel(data); // Actualiza el estado del hotel con los datos del backend
    }
  }, [data]);

  useEffect(() => {
   let data = dataDatosPago as any;
   if (data) {
    setDatosPago(data.content);
   }
   if (errorDatosPago) {
    console.log(errorDatosPago);
   }
  }, [dataDatosPago,errorDatosPago])
  

  const router = useNavigate();

  const [timeLeft, setTimeLeft] = useState(60 *10); // Tiempo restante en segundos
  const [isRunning, setIsRunning] = useState(true); // Estado para controlar si el temporizador está corriendo
  
   // Función para pausar el temporizador
   const pauseTimer = () => {
    setIsRunning(false); // Cambia el estado a false, deteniendo el temporizador
  };

  // Función para reanudar el temporizador desde el tiempo actual
  const resumeTimer = () => {
    setIsRunning(true); // Cambia el estado a true, reanudando el temporizador
  };

  useEffect(() => {

    if (!isRunning) return
    // Función para actualizar el tiempo restante
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setShowModal(true);
          setTitleModal("Tiempo agotado");
          setContentModal("El tiempo para realizar la transferencia ha agotado");
          return 0; // Para asegurarnos de que no sea negativo
        }
        return prevTime - 1; // Decrementa el tiempo restante
      });
    }, 1000); // Actualiza cada segundo

    return () => clearInterval(timer); // Limpia el intervalo al desmontar
  }, [isRunning]);


  const minutes = useMemo(() => Math.floor(timeLeft / 60),[timeLeft]);
  const seconds = useMemo(() => timeLeft % 60,[timeLeft]);

  const [isSubmitting, setIsSubmitting] = useState(false)

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [pdfURL, setPdfURL] = useState('');
  const [codigoComprobante, setCodigoComprobante] = useState("0")
  const [errorCodigoComprobante, setErrorCodigoComprobante] = useState("")
  const [bodyCrearReserva, setbodyCrearReserva] = useState({
    "codigo_pre_reserva": "",
    "codigo_comprobante": 0,
    "monto":0
  })
  const [errorBody, seterrorBody] = useState("")
  
  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      
      const fileURL = URL.createObjectURL(selectedFile);
      setPdfURL(fileURL); // Crea una URL para previsualizar el PDF
    }
  };



  const manejarKeyDown = (event: any) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
    }
  };
  function tieneNueveAlPrincipio(numero: number) {
    return numero.toString().charAt(0) === '9';
}
  const validarFormulario = () => {
    console.log("validarFormulario")
    if((bodyCrearReserva.codigo_comprobante !== null && bodyCrearReserva.codigo_comprobante.toString().length !== 11) || !tieneNueveAlPrincipio(bodyCrearReserva.codigo_comprobante)){
      seterrorBody("El codigo de comprobante debe tener 11 dígitos y empezar con 9");
      return false
    }else if(isNaN(bodyCrearReserva.monto) || bodyCrearReserva.monto <= 0 ){
      seterrorBody("El monto debe ser un número mayor que 0 y no debe estar vacio");
    }else{
      seterrorBody("")
    }
    return true
  }

  const handleInputChange = (event: any) => {
   const { name, value } = event.target;
   if (name === "monto"){
    setbodyCrearReserva((prevData) => ({
      ...prevData,[name]: event.target.valueAsNumber
    }))
   } else{
    setbodyCrearReserva((prevData) => ({
      ...prevData,[name]: value
    }))
   }
    
  }
  const handleTransferPayment = async () => {
    console.log("handleTransferPayment")
    if(!validarFormulario()){
      return
    }
    pauseTimer()
    setIsSubmitting(true)

    /*
    realizar peticion de transferencia
    */
    try {
      const response = await fetch(`${config.backend_url}/setia/reservas/crear_reserva_transferencia`,{
        method: "POST",
        headers: {
          "content-type": "application/json",
          "SetiaAuthorization": `${sessionStorage.getItem("user_token")}`
        },
        body: JSON.stringify(bodyCrearReserva)
      })
      if(response.ok){
        setTitleModal("Transferencia realizada")
        setContentModal("La transferencia se realizo correctamente. espere a que lo confirme el administrador")
        
      }else{
        setTitleModal("Error al realizar la transferencia")
        setContentModal("Hubo un error al realizar la transferencia, intentelo nuevamente")
      }
    } catch (error) {
      setTitleModal("Error al realizar la transferencia")
      setContentModal("Hubo un error al realizar la transferencia, intentelo nuevamente")
    }finally{
      setIsSubmitting(false)
      setShowModal(true)
    }
    
    
  }

  const renderSidebar = () => {

    const handleCancelPayment = () => {
      sessionStorage.removeItem("id_preferencia");
      sessionStorage.removeItem("preference_amount");
      sessionStorage.removeItem("roomsData");
      sessionStorage.removeItem("start_disp");
      sessionStorage.removeItem("end_disp");
      sessionStorage.removeItem("total_disp");
      sessionStorage.removeItem("guests_checkout");
      sessionStorage.removeItem("occupants");
      router('/listing-stay-detail', { replace: true });
    };

    const hotelCode = sessionStorage.getItem("selected_hotel") || "";
    const subtotal = sessionStorage.getItem("total_subtotal") || "";
    const total_noches = sessionStorage.getItem("total_noches") || "";

    return (

      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            Reserva:
            {/* <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
            /night
          </span> */}
          </span>
          {/* <StartRating /> */}
        </div>

        <SectionHotelData hotelCode={hotelCode} />
        {/* FORM */}
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInputView className="flex-1 z-[11]" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          <GuestsInputView className="flex-1" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          {/* datos de la distribucion de los huespedes */}
          <SectionGuestDistribution />
          <h1 className="pl-4 pb-2 text-sm font-semibold">Precio : {(Number(subtotal)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} X {total_noches} noches = {(Number(subtotal) * Number(total_noches)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</h1>

        </form>

        {/* SUBMIT */}
        <div>
          <button onClick={handleCancelPayment} className={`border w-full px-4 py-1.5 pb-3 bg-white hover:bg-neutral-200 text-red-500 text-md sm:px-6 sm:py-2.5 rounded-full focus:outline-none selected`}>Cancelar</button>
        </div>
      </div>
    );
  };

  
  const renderTransferPaymentForm = () => {
    return (
      <div >
        {showPaymentForm ? (
            <>
                {/* ALERT */}
                <div className="my-4">
                    <div
                        id="alert-2"
                        className="flex flex-row items-start md:items-center p-4 mb-6 text-red-800 rounded-lg bg-red-200 dark:bg-gray-800 dark:text-red-400"
                        role="alert"
                    >
                        <svg
                            className="flex-shrink-0 w-8 h-8 mr-2 mb-4 md:mb-0"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                        </svg>
                        <div className="ms-0 md:ms-4 text-lg md:text-base font-medium">
                           Tiempo para completar el pago: {minutes} minutos y {seconds} segundos...
                        </div>
                    </div>
                </div>

                <h1 className="text-2xl font-semibold">Datos para la transferencia</h1>
                <h1 className="text-lg font-normal">Puede utilizar cualquiera de los mostrados</h1>
                {/*<h1>SINDICATO DE EMPLEADOS TEXTILES DE LA IND </h1>
                <h1>CVU: 0000003100045151182274 </h1>
                <h1>Alias: setia.mp</h1>
                <h1>CUIT/CUIL: 30531126315</h1>
                <h1>Mercado Pago</h1>*/}
                {
                  datosPago.map((item: any, index) => (
                    <>
                      <h1>Titular: {item.titular}</h1>
                      <h1>CBU: {item.cbu} </h1>
                      <h1>Alias: {item.alias}</h1>
                      <h1>Nro de cuenta: {item.nro_cuenta}</h1>
                      
                    </>
                  ))
                }

                <form onSubmit={(e)=>{e.preventDefault();handleTransferPayment()}}>

                    <div className="my-4 flex flex-col">
                      <h1 className="text-2xl font-semibold">Complete los siguientes datos</h1>  
                        {/*<Label >Nombre y Apellido del titular del comprobante</Label>
                        <Input type="text" id="nombre_completo" placeholder="Nombre y apellido" required />*/}

                        <Label className="mt-4" >Numero de comprobante de Mercado Pago</Label>
                        <Input type="number"  id="codigo_comprobante" name="codigo_comprobante" placeholder="Ej: 98765432123" onChange={handleInputChange} onKeyDown={manejarKeyDown}  onWheel={(e) => e.currentTarget.blur()} required />
                    

                        <Label className="mt-4" >Monto Pagado</Label>
                        <Input type="number"  id="monto" name="monto" placeholder="Ej: 10000" onChange={handleInputChange} onKeyDown={manejarKeyDown}  onWheel={(e) => e.currentTarget.blur()} required />

                        {errorBody && <p className="my-4 text-red-500">{errorBody}</p>}
                        {/*<label htmlFor="file-upload" style={{...buttonStyles, textAlign: 'center'}}>
                           {file ? 'Cambiar archivo' : 'Seleccionar foto de comprobante'} 
                        </label>
                        <input
                            type="file"
                            id="file-upload"
                            onChange={handleFileChange}
                            style={{ display: 'none' }} // Ocultamos el input para usar solo el label
                            accept="application/pdf" // Aceptar solo PDFs
                        />*/}
                        {/*file !== null && fileName && <p className="my-4">Archivo seleccionado: {fileName}</p>*/} {/* Mostramos el nombre del archivo */}
                        {/*pdfURL && (
                            <>
                                <div className="hidden lg:flex lg:justify-center">
                                    <iframe
                                    src={pdfURL}
                                    width="100%"
                                    height="500"
                                    title="Previsualización del PDF"
                                    />
                                </div>
                            
                                <button className="lg:hidden" onClick={(e)=>{e.preventDefault();window.open(pdfURL, '_blank');}} style={{...buttonStyles}}>Ver PDF</button>
                                
                                
                            </>

                           
                        )*/} 
                         {/*file !== null && <button type="submit" style={{...buttonStyles}} className={`${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`} disabled={isSubmitting}>{(isSubmitting) ? "Enviando..." : "Enviar datos"}</button> */}
                        <button type="submit" style={{...buttonStyles}} className={`${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`} disabled={isSubmitting}>{(isSubmitting) ? "Enviando..." : "Enviar datos"}</button>
                    </div>
                </form>

                
            </>
          
        ) : (
          <>
            {errorMessage && <div className="text-red-500 mt-2">{errorMessage}</div>}
          </>
        )}
      </div>
    );
  };

  const renderMain = () => {
    const hotelCode = sessionStorage.getItem("selected_hotel") || "";
    return (
      <>
        <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
          <h2 className="text-3xl lg:text-4xl font-semibold">
            Pago de Reserva
          </h2>
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

          {/* <form className="flex flex-center border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInputView className="w-full" />
          <GuestsInputView className="w-full" />
        </form> */}
          <div className="space-y-8  lg:hidden">
            <h2 className="text-2xl font-semibold">Hotel:</h2>
            <SectionHotelData hotelCode={hotelCode} />
            {/* FORM */}
            <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
              <StayDatesRangeInputView className="flex-1 z-[11]" />
              <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
              <GuestsInputView className="flex-1" />
              <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
              {/* datos de la distribucion de los huespedes */}
              <SectionGuestDistribution />
            </form>
          </div>

          <h2 className="pl-2 text-2xl font-semibold">Pagás {datosMockeados?.monto_senia.toLocaleString('en-US', { style: 'currency', currency: 'USD' })} { pagoCompleto ? "( 100% de la reserva)" : "( 50% de la reserva)"}</h2>

        </div>
        {renderTransferPaymentForm()}
        {renderModal()}
      </>
    );
  };

  const handleContinuarModal = () =>{
    setShowModal(false);
    if(!titleModal.includes("Error")){
      router('/')
      return
    }
    resumeTimer()
  }
  const renderModal = () => {
    return(showModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-96">
          <h2 className="text-xl font-semibold mb-4">{titleModal}</h2>
          <p className="mb-4">{contentModal}</p>
          <div className="flex justify-end space-x-4">
            {/* <button
              onClick={() =>{setShowModal(false);resumeTimer()}}
              className="bg-gray-500 text-white px-4 py-2 rounded-full hover:bg-gray-600"
            >
              Cancelar
            </button> */}
            <button
              onClick={handleContinuarModal}
              className="bg-blue-600 rounded-full text-white px-4 py-2"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    ))
  }


  if (!hotel) {
    return null; // Evitar renderizar si no hay datos de hotel
  }

  return (
    <div className={`nc-CheckOutPagePageMain ${className}`}>
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10">
          {renderMain()}
        </div>
        <div className="hidden lg:block flex-grow">
          {renderSidebar()}
        </div>
      </main>
    </div>
  );
};

export default TransferPayment;

const containerStyles: CSSProperties = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    margin: '20px auto',
  };
  
  const formStyles: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
  };
  
  const titleStyles: CSSProperties = {
    textAlign: 'center',
    marginBottom: '20px',
    fontSize: '24px',
    fontWeight: '500',
  };
  
  const inputStyles: CSSProperties = {
    padding: '6px',
    fontSize: '14px',
    marginBottom: '15px',
    borderRadius: '50px',
    border: '1px solid #ccc',
    width: '100%',
    height: '38px',
  };
  
  const buttonStyles: CSSProperties = {
    backgroundColor: '#2563eb',
    color: 'white',
    fontSize: '18px',
    border: 'none',
    borderRadius: '50px',
    padding: '10px',
    cursor: 'pointer',
    // width: '100%',
    marginTop: '10px',
  };
  
  const errorStyles: CSSProperties = {
    color: 'red',
    textAlign: 'center',
    marginBottom: '15px',
  };
  
  const successStyles: CSSProperties = {
    color: 'green',
    textAlign: 'center',
    marginBottom: '15px',
  };
  